import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { CommentReadsActions } from '@store/reducers/commentReads'
import { ThreadsActions } from '@store/reducers/threads'
import { useDispatch, useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { GlobalActions, OpenConfirmation } from '@/store'

const useLinkSelector = (threadId: ID) => {
  const projectId = useSelector(migrationProjectSelector.getProjectId)
  const tabId = useSelector(migrationProjectSelector.getActiveOrFirstTabId)

  const { origin } = window.location

  return `${origin}/${projectId}/${tabId}/thread/${threadId}/comments`
}

export const useThreadActions = (threadId: ID) => {
  const dispatch = useDispatch()

  const link = useLinkSelector(threadId)

  const onDelete = () =>
    dispatch(
      OpenConfirmation({
        label: 'Delete',
        message: 'Thread will be permanently deleted. Are you sure?',
        title: 'Delete thread',
        then: [ThreadsActions.delete({ id: threadId })],
      })
    )

  const onCopyLink = () => {
    dispatch(GlobalActions.copy({ value: link }))
    sendGtmEvent(GtmTriggerName.COPY_THREAD_LINK)
  }

  const onMarkUnread = () =>
    dispatch(CommentReadsActions.markUnread({ target: threadId }))

  return { onDelete, onCopyLink, onMarkUnread }
}
